// チームリーグ用プレイヤー選択UI（playType〜MAX_SESSION_PLAYERS 人を選択、playType 超過時にモーダルで playType 人に絞る）
$(document).on('turbolinks:load', function() {
  var $container = $('.team-select-players');
  if (!$container.length) return;

  var playType = parseInt($container.data('play-type'), 10);
  var maxPlayers = parseInt($container.data('max'), 10) || playType;
  var i18n = {
    unselected: $container.data('unselected'),
    modalTitle: $container.data('modal-title')
  };
  var selectedPlayers = []; // [{ teamId, playerId, playerName }, ...]

  var playerSelectModal = window.PlayerSelectModal ? new window.PlayerSelectModal() : null;

  function getSelectedCount() {
    return selectedPlayers.length;
  }

  function findByPlayerId(playerId) {
    return selectedPlayers.find(function(p) { return p.playerId === playerId; }) || null;
  }

  function removeByPlayerId(playerId) {
    selectedPlayers = selectedPlayers.filter(function(p) { return p.playerId !== playerId; });
  }

  function updateUI() {
    var count = getSelectedCount();
    var isFull = count >= maxPlayers;

    // カード単位の有効/無効（満員かつ未選択のカードのみ disabled）
    $container.find('.team-player-card').each(function() {
      var playerId = $(this).data('player-id');
      var isSelected = !!findByPlayerId(playerId);
      $(this).toggleClass('is-disabled', !isSelected && isFull);
    });

    // 選択スロット更新
    for (var i = 0; i < maxPlayers; i++) {
      var $slot = $('.selection-slot[data-slot="' + i + '"]');
      if (i < selectedPlayers.length) {
        var sp = selectedPlayers[i];
        var $group = $container.find('.team-select-group[data-team-id="' + sp.teamId + '"]');
        var teamColor = $group.data('team-color');
        var teamLogo = $group.data('team-logo');
        var teamName = $group.data('team-name');

        var $slotIcon = $slot.find('.slot-icon');
        $slotIcon.removeClass('empty').addClass('filled');
        if (teamLogo) {
          $slotIcon.css('background-color', '').html('<img src="' + teamLogo + '" alt="' + teamName + '">');
        } else {
          $slotIcon.css('background-color', teamColor).text(teamName[0]);
        }
        $slot.find('.slot-name').text(sp.playerName).css({ 'font-weight': 600, 'color': '#333' });
      } else {
        $slot.find('.slot-icon').addClass('empty').removeClass('filled').css('background-color', '').text(i + 1);
        $slot.find('.slot-name').text(i18n.unselected).css({ 'font-weight': 400, 'color': '#888' });
      }
    }

    // FABボタン
    var $fab = $('.team-select-fab-btn');
    if (count >= playType && count <= maxPlayers) {
      $fab.removeClass('disabled').addClass('enabled');
      $fab.find('.fab-counter').text('✓');
    } else {
      $fab.addClass('disabled').removeClass('enabled');
      $fab.find('.fab-counter').text(count + '/' + playType + '~' + maxPlayers);
    }

    // hidden fields更新
    $('#team-player-ids').empty();
    $('#team-participant-ids').empty();
    $('#team-participant-names').empty();
    selectedPlayers.forEach(function(sp) {
      $('#team-player-ids').append('<input type="hidden" name="player_ids[]" value="' + sp.playerId + '">');
      $('#team-participant-ids').append('<input type="hidden" name="participant_ids[]" value="' + sp.playerId + '">');
      $('#team-participant-names').append('<input type="hidden" name="participant_names[]" value="' + sp.playerName + '">');
    });

    // カード選択状態
    $container.find('.team-player-card').each(function() {
      var playerId = $(this).data('player-id');
      var isSelected = !!findByPlayerId(playerId);
      $(this).toggleClass('selected', isSelected);
      if (isSelected) {
        var teamColor = $(this).closest('.team-select-group').data('team-color');
        $(this).css('border-color', teamColor);
        $(this).find('.player-name-text').css({ 'font-weight': 700, 'color': teamColor });
      } else {
        $(this).css('border-color', '');
        $(this).find('.player-name-text').css({ 'font-weight': '', 'color': '' });
      }
    });

    // 選択済みバッジ（同チーム複数人: 1人1バッジ）
    $container.find('.team-select-chosen').each(function() {
      var $badge = $(this);
      var teamId = $badge.closest('.team-select-group').data('team-id');
      var teamSelections = selectedPlayers.filter(function(p) { return p.teamId === teamId; });
      $badge.empty();
      if (teamSelections.length > 0) {
        var teamColor = $badge.closest('.team-select-group').data('team-color');
        teamSelections.forEach(function(p) {
          $badge.append(
            $('<span>', { class: 'team-select-chosen__tag' })
              .text(p.playerName)
              .css({ 'color': teamColor, 'background-color': teamColor + '15' })
          );
        });
        $badge.show();
      } else {
        $badge.hide();
      }
    });
  }

  // プレイヤーカードクリック
  $(document).on('click', '.team-player-card', function() {
    if ($(this).hasClass('is-disabled')) return;

    var teamId = $(this).closest('.team-select-group').data('team-id');
    var playerId = $(this).data('player-id');
    var playerName = $(this).data('player-name');

    // 選択済み → 解除
    if (findByPlayerId(playerId)) {
      removeByPlayerId(playerId);
    }
    // 未選択 → 上限未満なら追加
    else if (getSelectedCount() < maxPlayers) {
      selectedPlayers.push({ teamId: teamId, playerId: playerId, playerName: playerName });
    }

    updateUI();
  });

  // FABクリック → フォーム送信（またはモーダル表示）
  $(document).on('click', '.team-select-fab-btn.enabled', function() {
    var count = getSelectedCount();

    // playType を超えて選択時（抜け番あり）→ モーダルで playType 人に絞る
    if (count > playType) {
      if (!playerSelectModal) return;

      var items = [];
      selectedPlayers.forEach(function(sp) {
        items.push({ id: sp.playerId, name: sp.playerName });
      });

      playerSelectModal.open({
        items: items,
        limit: playType,
        title: i18n.modalTitle,
        onConfirm: function(selectedIds, _selectedNames) {
          // player_ids = モーダルで選択された play_type 人
          // participant_ids/names = 全選択の maxPlayers 人
          var $form = $('#team-select-form');
          $('#team-player-ids').empty();
          selectedIds.forEach(function(id) {
            $('#team-player-ids').append('<input type="hidden" name="player_ids[]" value="' + id + '">');
          });
          // participant は全選択者
          $('#team-participant-ids').empty();
          $('#team-participant-names').empty();
          selectedPlayers.forEach(function(sp) {
            $('#team-participant-ids').append('<input type="hidden" name="participant_ids[]" value="' + sp.playerId + '">');
            $('#team-participant-names').append('<input type="hidden" name="participant_names[]" value="' + sp.playerName + '">');
          });
          $form.submit();
        }
      });
      return;
    }

    // playType人選択時 → 直接送信
    $('#team-select-form').submit();
  });

  updateUI();
});
